import React from "react";

const NotFound = () => {
  return (
    <div className="hold-transition login-page">
      <h1>404 - Página no encontrada</h1>
    </div>
  );
};

export default NotFound;
